import { useEffect, useState } from "react"
import { useAuth } from "../../context/authContext"
import CustomTable from "../../component/form/TableComponent";
import { TableButtons } from "../../types/TableComponent.types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faL, faMailBulk, faStop, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useLoading } from "../../context/loadingContext";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../context/notificationContext";
import { LoadingScreenLocal } from "../other/LoadingScreen";
import * as Invitation from "../../api/invitation";
import { isSuccessCode } from "../../helpers/apiResponse";

export const ViewInvitationScreen: React.FC = () => {

    const [user, setUser] = useState<any[]>([]);
    const nav = useNavigate();

    const { loading, setLoadingStatus } = useLoading();
    const { addNotification } = useNotification();


    const handleRevoke = (token: string) => {
        setLoadingStatus(true);
        Invitation.revoke(token).then(response => {
            if (isSuccessCode(response.error_code)) {
                displayInvitations().then(() => setLoadingStatus(false))
                addNotification("Invitation revoked", "Invitation has been revoked", "success");
            } else {
                nav("/500?process_id=" + response.request_id + "&error_code=" + response.error_code);
            }
        })
    }

    const handleResend = (token: string) => {
        setLoadingStatus(true);
        Invitation.resend(token).then(response => {
            if (isSuccessCode(response.error_code)) {
                displayInvitations().then(() => setLoadingStatus(false))
                addNotification("Invitation resent", "Invitation has been resent", "success");
            } else {
                nav("/500?process_id=" + response.request_id + "&error_code=" + response.error_code);
            }
        })
    }

    const columns = [
        { header: 'Email', accessor: 'email' },
        { header: 'Role', accessor: 'role' },
        { header: 'Invitation status', accessor: 'status' },
        { header: 'Issued date', accessor: 'creation_at' },
        { header: 'Expiry date', accessor: 'expire_at' },
    ];

    const buttons: TableButtons[] = [
        {
            button: (<FontAwesomeIcon icon={faCancel} title="Revoke" />),
            bc: "red",
            placeholder: "Revoke",
            action: { param: "token", function: handleRevoke }
        },
        {
            button: (<FontAwesomeIcon icon={faMailBulk} title="Resend" />),
            bc: "green",
            placeholder: "Resend",
            action: { param: "token", function: handleResend }
        }
    ];

    const displayInvitations = async () => {
        const request = await Invitation.list();
        if (isSuccessCode(request.error_code)) {
            const updatedUsers = request.data.map((user: any) => {
                return { ...user };
            });
            setUser(updatedUsers);
            setLoadingStatus(false)
        } else {
            setLoadingStatus(false)
            nav("/500?process_id=" + request.request_id + "&error_code=" + request.error_code);
        }
    }


    useEffect(() => {
        setLoadingStatus(true)
        displayInvitations();
    }, [])

    if (loading)
        return (<LoadingScreenLocal />)
    return (
        <CustomTable
            columns={columns}
            buttons={buttons}
            data={user}
        />
    )
}
